import { Chip } from "@mui/material"
import { requestStatusActafoia, requestStatus, IStatus } from "../models/request";

const RequestStatusChip = (props:any) => {

    let status:string = props.request.status;
    if(props.statusUpdate){
        status = props.statusUpdate.status;
    }

    const label = props.request.module.actafoia_enabled ? (requestStatusActafoia[status  as keyof typeof  requestStatusActafoia] as any)?.label : (requestStatus[status  as keyof typeof  requestStatus] as any)?.label;

    switch(status){
        case "draft":
            return (
                <Chip className="request_status_chip draft" label={label} color={"info"} variant="outlined" />
            )
        case "cancelled":
            return (
                <Chip className="request_status_chip cancelled" label={label} color={"error"} variant="outlined" />
            )
        case "under_review":
            return (
                <Chip className="request_status_chip under_review" label={label} color={"primary"} variant="outlined" />
            )
        case "waiting_payment":
            return (
                <Chip className="request_status_chip waiting_payment" style={{ display: props.showAll ? "none" : undefined }} label={label} color={"primary"} variant="outlined" />
            )
        case "waiting_review":
            return (
                <Chip className="request_status_chip waiting_review" label={label} color={"primary"} variant="outlined" />
            )
        case "waiting_integration":
            return (
                <Chip className="request_status_chip waiting_integration" label={label} color={"primary"} variant="outlined" />
            )
        case "approved":
            return (
                <Chip className="request_status_chip approved" label={label} color={"success"} variant="outlined" />
            )
        case "completed":
            return (
                <Chip className="request_status_chip completed" label={label} color={"success"} variant="outlined" />
            )
        case "actafoia_accepted":
            return (
                <Chip className="request_status_chip actafoia_accepted" label={label} color={"success"} variant="outlined" />
            )
        case "actafoia_deferred":
            return (
                <Chip className="request_status_chip actafoia_deferred" label={label} color={"warning"} variant="outlined" />
            )
        case "actafoia_partially_rejected":
            return (
                <Chip className="request_status_chip actafoia_partially_rejected" label={label} color={"error"} variant="outlined" />
            )
        case "actafoia_rejected":
            return (
                <Chip className="request_status_chip actafoia_rejected" label={label} color={"error"} variant="outlined" />
            )
        case "actafoia_tranfered":
            return (
                <Chip className="request_status_chip actafoia_tranfered" label={label} color={"primary"} variant="outlined" />
            )
        default:
            return null;
    }
}
export default RequestStatusChip;